import React from 'react';
import Type from 'prop-types';
import { Avatar, Tooltip } from "@mui/material";
import styles from './GroupCounters.module.css';

export const GroupCounters = (props) => {
  const { values } = props;

  return (
    <div className={styles.counterWrapper}>
      {values.map((counter) => (
        <Tooltip key={counter.id} title={counter.tip}>
          <Avatar
            style={{ backgroundColor: counter.colorBadge }}
            className={styles.countBadge}
          >
            {counter.value}
          </Avatar>
        </Tooltip>
      ))}
    </div>
  );
};

GroupCounters.propTypes = {
  values: Type.arrayOf(
    Type.shape({
      value: Type.number.isRequired,
      tip: Type.oneOfType([Type.string, Type.number]),
      colorBadge: Type.string.isRequired,
    }),
  ),
};

GroupCounters.defaultProps = {
  values: [],
};
